module.exports = __webpack_public_path__ + "static/AvenirNext-DemiBold-5f650f8eb3911edd07325c21861d887e.woff";